import { render, staticRenderFns } from "./CriterionCreator.vue?vue&type=template&id=5dd6a24e&scoped=true"
import script from "./CriterionCreator.vue?vue&type=script&lang=ts"
export * from "./CriterionCreator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6a24e",
  null
  
)

export default component.exports